import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const UnsubscribeBan = () => (
  <ImageIcon src={Images.UnsubscribeBan} alt="Unsubscribe Ban" />
);

export default UnsubscribeBan;
